var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "rbvSelect",
      class: { focused: _vm.focused, opened: _vm.opened },
    },
    [
      _c(
        "div",
        {
          staticClass: "control",
          class: { focused: _vm.focused, opened: _vm.opened },
          on: {
            mousedown: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onInputClicked.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "valueContainer" }, [
            !_vm.selected && !_vm.hasQuery
              ? _c("div", { staticClass: "selectPlaceholder" }, [
                  _vm._v(_vm._s(_vm.placeholder)),
                ])
              : _vm._e(),
            _c("div", { staticClass: "selectValue" }, [
              _vm._v(" " + _vm._s(_vm.hasQuery ? "" : _vm.viewValue) + " "),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.query,
                  expression: "query",
                },
              ],
              staticClass: "selectInput",
              attrs: { autocomplete: "off", role: "combobox", type: "text" },
              domProps: { value: _vm.query },
              on: {
                focus: _vm.onInputFocused,
                blur: _vm.onInputBlurred,
                keydown: function ($event) {
                  $event.stopPropagation()
                  return _vm.onInputKeyDown.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.query = $event.target.value
                },
              },
            }),
          ]),
          _vm.selected
            ? _c("div", { staticClass: "clearContainer" }, [
                _c(
                  "div",
                  {
                    staticClass: "clear material-icons",
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.onClearClicked.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("clear")]
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "arrowContainer" }, [
            _c("div", { staticClass: "arrow material-icons" }, [
              _vm._v(_vm._s(_vm.arrow)),
            ]),
          ]),
        ]
      ),
      _vm.opened
        ? _c("div", { staticClass: "overlayContainer" }, [
            _c("div", { staticClass: "overlay" }),
          ])
        : _vm._e(),
      _c("transition", { attrs: { name: "rbvSelectFade" } }, [
        _vm.opened
          ? _c("div", { staticClass: "optionsContainer" }, [
              _c(
                "div",
                { staticClass: "optionsScrollContainer" },
                [
                  !_vm.filteredOptions || !_vm.filteredOptions.length
                    ? _c("div", { staticClass: "noOptions" }, [
                        _vm._v("No Items Found"),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.filteredOptions, function (option) {
                    return _c("rbv-option", {
                      key: option.id,
                      staticClass: "option",
                      attrs: {
                        option: option,
                        selected: _vm.selected,
                        marked: _vm.marked,
                        highlight: _vm.query,
                        scroll: _vm.scrollOptions,
                        "label-key": _vm.labelKey,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onOptionClicked(option)
                        },
                        hover: function ($event) {
                          return _vm.onOptionHovered(option)
                        },
                      },
                    })
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }